module.exports = __webpack_public_path__ + "static/media/product_road_map.bc5d19a8.svg";